import React, {useState, useEffect} from "react";
import Header from '../Components/Header';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ReactSession } from 'react-client-session';
ReactSession.setStoreType("localStorage");

function Jutebags() {
  const userId=ReactSession.get("welbeingId");
     const navigate = useNavigate();
     const [jutebag, setjutebag] = useState([]);
     const[formDatas, setfromDatas]= useState({}); 
    const [error, setError] = useState(""); 
    const [file, setFile] = useState(""); 
     const [jutebagdesc, setJutebagdesc] = useState({
    id: "",
    jute_description: ""
  });
   

  if(userId  <= 0 ){
      navigate('/login');
   }


 
    const jutebags = async() =>{
        try{
            const response = await axios.get('https://api.welbeing.in/admin/customize/jute/get/');
            console.log(response.data.data);
            if(response.data.status==="success"){
            
            setjutebag(response.data.data.jutebag);
            setJutebagdesc(response.data.data.description);
            }else{
               console.error(response.data.error?.message);
            }
        }catch (err) {
             setError(err.message);
                
        }
    };


       useEffect(() => {
       jutebags();
    }, []);


    const handleDescriptionChange = (id, value) => {
     setJutebagdesc(prev => ({
      ...prev,
      jute_description: value
    }));
  };

  



  const handlechange = async() =>{

    const formdata={
        id:jutebagdesc.id,
        des:jutebagdesc.jute_description
    }

    console.log(formdata);
    
        try{
            const response = await axios.post('https://api.welbeing.in/admin/customize/jute/edit-des/', formdata);
            console.log(response.data.data);
            if(response.data.status==="success"){
          //  jutebags();
            }else{
               console.error(response.data.error?.message);
            }
        }catch (err) {
             setError(err.message);
                
        }
    };



     const handlechanges =(e)=>{
        const name=e.target.name;
        const value=e.target.value;
        setfromDatas(values=> ({...values, [name]:value}))

    }


    const handlesubmit = async(e) =>{
        e.preventDefault();
        const formData = new FormData();
        formData.append('size', formDatas.size);
        formData.append('price', formDatas.price);
        formData.append('image', file);
        formData.append('material', formDatas.material);
        formData.append('description', formDatas.description);

        try{
          const response = await axios.post('https://api.welbeing.in/customize/jute/add/', formData);
            console.log(response.data);
          if(response.data.status === "success"){
            navigate("/jute");
          }else{
            console.log(response.error);
          }
        }catch (err) {
             setError(err.message);
                
        }
    };


    const handleFile = (event) => {
        setFile(event.target.files[0]); // Only taking the first file if multiple files are selected
    };


    const handleDelete = async(id) =>{
        try{
          const response = await axios.post('https://api.welbeing.in/admin/customize/jute/delete/', {id:id});
            console.log(response.data);
          if(response.data.status === "success"){
             jutebags();
            navigate("/jute");
          }else{
            console.log(response.error);
          }
        }catch (err) {
             setError(err.message);
                
        }
    }


  return (
    <>
      
      <Header />
      <div className="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        <div className="body-wrapper">
          <div className="container-fluid">
            <div className="card bg-light-info shadow-none position-relative overflow-hidden">
              <div className="card-body px-4 py-3">
                <div className="row align-items-center">
                  <div className="col-9">
                    <h4 className="fw-semibold mb-8">Homepage Content</h4>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a className="text-muted" href="/dashboard">Dashboard</a></li>
                        <li className="breadcrumb-item" aria-current="page">Homepage content</li>
                      </ol>
                    </nav>
                  </div>
                  <div className="col-3">
                    <div className="text-center mb-n5">  
                      <img src="dist/images/breadcrumb/ChatBc.png" alt="" className="img-fluid mb-n4"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content Section */}
            <section>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4>Jute Bag</h4>
                      <div className="mb-2">
                        <h5 className="mb-0"></h5>
                      </div>
                      <div className="table-responsive">
                        <section>
                          <div className="row">
                           
                              <div className="col-md-12">
                                <div className="mb-3">
                                  <label>Description</label>
                                  
                                   <textarea className="form-control" rows="3" name="des" id="classic-editor" style={{ padding: '30px' }} key={jutebagdesc.id}
                                     value={jutebagdesc.jute_description}
                                     onChange={(e) => handleDescriptionChange(jutebagdesc.id, e.target.value)}
                                   />
                                 
                                    </div>
                              </div>
                              <div className="form-actions">
                                <div className="text-start">
                                  <button type="submit" className="btn btn-light-primary text-primary font-medium mb-5" onClick={handlechange}>Edit</button>
                                </div>
                              </div>
                            
                          </div>

                          <div className="row">
                            {Array.isArray(jutebag) && jutebag.map((item) => (
                             <div className="col-lg-3 col-md-6 col-12 mb-4" key={item.id || item.jute_id}> {/* Always add keys in React */}
                               <div className="card h-100"> {/* Better height handling */}
                                 <div className="card-body">
                                   {/* Delete button - make sure to use item.id from your data */}
                                   <div className="btn-group float-end"> {/* Better positioning */}
                                     <a 
                                       className="btn btn-danger bg-gradient-danger" 
                                      onClick={(e) => handleDelete(item.id)}// Dynamic ID
                                     >
                                       <i className="ti ti-trash"></i>
                                     </a>
                                   </div>
                           
                                   {/* Product image - use dynamic src if available */}
                                   <div className="d-flex align-items-center mb-3">
                                     <img 
                                       src={item.image} 
                                       className="rounded-circle" 
                                       width="100" 
                                       height="100" 
                                       alt={item.description || "Jute bag"} 
                                     />
                                   </div>
                           
                                   {/* Product details - using dynamic data */}
                                   <p><b>Size: </b> {item.size }</p>
                                   <p><b>Price: </b> {item.price}</p>
                                   <p><b>Material: </b> {item.material}</p>
                                   <p><b>Description: </b> 
                                     {item.description}
                                   </p>
                                 </div>
                               </div>
                             </div>
                             ))}
                           

                            <div className="col-lg-5 col-md-6 col-12">
                              <div className="card" style={{minHeight: '200px'}}>
                                <div className="card-body">
                                  <form onSubmit={handlesubmit}>
                                    <div className="row">
                                       <div className="col-md-12" style={{marginLeft: '10px'}}>
                                        <div className="mb-3">
                                          <label htmlFor="image">Image:</label>
                                          <input type="file" className="form-control" name="image" id="image" accept="image/*"  onChange={handleFile}/>
                                          <br />
                                          <label htmlFor="size">Size:</label>
                                          <input type="text" className="form-control" name="size" id="size" value={formDatas.size} onChange={handlechanges}/>
                                          <br />
                                          <label htmlFor="price">Price:</label>
                                          <input type="text" className="form-control" name="price" id="price" value={formDatas.price} onChange={handlechanges}/>
                                          <br />
                                          <label htmlFor="material">Material:</label>
                                          <input type="text" className="form-control" name="material" id="material" value={formDatas.material} onChange={handlechanges}/>
                                          <br />
                                          <label htmlFor="description">Description:</label>
                                          <textarea className="form-control" rows="3" name="description" id="description" value={formDatas.description} onChange={handlechanges}></textarea>
                                        </div>
                                      </div>
                                      <div className="btn-group mb-3">
                                       <input type="submit" value="Add" className="btn btn-warning w-25"/>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default Jutebags;